import { withStyles } from '@glu/theming';
import { Fade } from '@glu/transitions-react';
import locale from '@glu/locale';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './DialogWrapper.styles';

const DialogWrapper = ({
  children,
  className,
  classes,
  hideBackdrop,
  show,
  mountOnEnter,
  transition: Transition,
  unmountOnExit,
  transitionIn,
  closeModal
}) => {
  const showTransition = show && transitionIn;

  const transitionProps = typeof Transition === 'string' ? {} : {
    in: show && transitionIn,
    mountOnEnter,
    unmountOnExit
  };

  return (
    <section className={classes.modalComponent}>
      <div
        className={classNames(className, classes.root, { [classes.modalIn]: show })}
        role="dialog"
      >
        {hideBackdrop ? null : (
          <Fade in={showTransition} mountOnEnter={mountOnEnter} unmountOnExit={unmountOnExit}>
            <div
              className={classes.backdrop}
              role="button"
              onClick={closeModal}
              onKeyUp={closeModal}
              tabIndex="0"
              aria-label={locale.get('close')}
            />
          </Fade>
        )}

        <Transition {...transitionProps}>
          {children}
        </Transition>
      </div>
    </section>
  );
};

DialogWrapper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  classes: PropTypes.objectOf(PropTypes.string),
  className: PropTypes.string,
  hideBackdrop: PropTypes.bool,
  mountOnEnter: PropTypes.bool,
  show: PropTypes.bool,
  transition: PropTypes.oneOfType([
    PropTypes.func, PropTypes.node, PropTypes.string, PropTypes.object
  ]),
  unmountOnExit: PropTypes.bool,
  transitionIn: PropTypes.bool,
  closeModal: PropTypes.func.isRequired
};

DialogWrapper.defaultProps = {
  children: [],
  classes: {},
  className: '',
  hideBackdrop: false,
  mountOnEnter: true,
  show: false,
  transition: Fade,
  unmountOnExit: true,
  transitionIn: true
};

export const DialogWrapperBase = DialogWrapper;
export default withStyles(styles)(DialogWrapper);
